import * as React from "react";
import { JSX } from "react/jsx-runtime";
const MapIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_627_30457)">
      <path
        d="M10.1 5.52539C10.1 4.27539 9.09998 3.27539 7.84998 3.27539C6.59998 3.27539 5.59998 4.27539 5.59998 5.52539C5.59998 6.77539 6.59998 7.77539 7.84998 7.77539C9.09998 7.77539 10.1 6.77539 10.1 5.52539ZM6.72498 5.52539C6.72498 4.90039 7.22498 4.40039 7.84998 4.40039C8.47498 4.40039 8.97498 4.90039 8.97498 5.52539C8.97498 6.15039 8.47498 6.65039 7.84998 6.65039C7.22498 6.65039 6.72498 6.15039 6.72498 5.52539Z"
        fill="#004E9B"
      />
      <path
        d="M15.55 14.7252L14.525 10.1002C14.475 9.8752 14.3 9.7002 14.05 9.6752L11.075 9.2502C12.025 7.9002 12.8 6.4752 12.8 5.3752C12.8 2.7252 10.575 0.575195 7.84999 0.575195C5.12499 0.575195 2.89999 2.7252 2.89999 5.3752C2.89999 6.4752 3.67499 7.9002 4.62499 9.2502L1.62499 9.6752C1.37499 9.7002 1.19999 9.9002 1.14999 10.1502L0.449989 14.7752C0.424989 14.9752 0.499989 15.1752 0.649989 15.3002C0.799989 15.4252 0.999989 15.4752 1.19999 15.4002L4.49999 14.2502L7.82499 15.3752C7.94999 15.4252 8.07499 15.4252 8.17499 15.3752L11.5 14.2502L14.825 15.3752C14.875 15.4002 14.95 15.4002 15 15.4002C15.125 15.4002 15.275 15.3502 15.375 15.2502C15.525 15.1502 15.6 14.9252 15.55 14.7252ZM7.84999 1.7002C9.97499 1.7002 11.675 3.3502 11.675 5.3752C11.675 6.7502 9.69999 9.37519 7.84999 11.4002C5.99999 9.4002 4.02499 6.7502 4.02499 5.3752C4.02499 3.3502 5.72499 1.7002 7.84999 1.7002ZM11.675 13.1252C11.55 13.0752 11.425 13.0752 11.325 13.1252L7.99999 14.2502L4.67499 13.1252C4.54999 13.0752 4.42499 13.0752 4.32499 13.1252L1.69999 14.0252L2.19999 10.7502L5.37499 10.2752C5.94999 11.0002 6.54999 11.6752 7.02499 12.2002C7.22499 12.4252 7.52499 12.5502 7.82499 12.5502C8.12499 12.5502 8.42499 12.4252 8.62499 12.2002C9.09999 11.6752 9.69999 11.0002 10.275 10.2752L13.525 10.7502L14.25 14.0002L11.675 13.1252Z"
        fill="#004E9B"
      />
    </g>
    <defs>
      <clipPath id="clip0_627_30457">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MapIcon;
